import React, { useState } from 'react';

export default function ContactPage() {
  const [form, setForm] = useState({name:'',email:'',phone:'',msg:''});
  const [sent, setSent] = useState(false);
  const handle = (e) => setForm({...form,[e.target.name]:e.target.value});
  const submit = () => { setSent(true); setForm({name:'',email:'',phone:'',msg:''}); setTimeout(()=>setSent(false),4000); };
  return (
    <>
      <div className="page-hero">
        <h2>Contact Us</h2>
        <p>We'd love to hear from you — reach out anytime</p>
      </div>
      <section className="contact">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <div className="section-tag">Get In Touch</div>
              <h3>We're Here for You &amp; Your Child</h3>
              <p>Feel free to visit us, call us or drop us an email. Our team is always happy to answer your queries about admissions, programs or anything else.</p>
              <div className="contact-details">
                {[['navy','📞','Phone','+ 91 8553852843','+ 91 9535487630'],['gold','✉️','Email','bschoolbelur@gmail.com'],['red','📍','Address','Belur – Chikkanasabi, Karnataka']].map(([c,ic,l,v]) => (
                  <div className="contact-detail-item" key={l}>
                    <div className={`contact-detail-icon ${c}`}>{ic}</div>
                    <div><div className="contact-detail-label">{l}</div><div className="contact-detail-val">{v}</div></div>
                  </div>
                ))}
              </div>
              <div style={{marginTop:'32px',background:'var(--gray-bg)',borderRadius:'16px',padding:'24px'}}>
                <h4 style={{fontFamily:'Poppins',fontWeight:'700',color:'var(--navy)',marginBottom:'12px'}}>🕒 School Hours</h4>
                {[['Monday – Friday','9:00 AM – 5:00 PM'],['Saturday','8:00 AM – 12:00 AM'],['Sunday','Closed']].map(([d,t]) => (
                  <div key={d} style={{display:'flex',justifyContent:'space-between',fontSize:'14px',padding:'8px 0',borderBottom:'1px solid #eee',color:'#555'}}>
                    <span style={{fontWeight:'600'}}>{d}</span><span>{t}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="contact-form">
              <h3>Send Us a Message</h3>
              {sent && <div style={{background:'#f8f9fc',border:'1px solid #dbe3f0',borderRadius:'10px',padding:'14px',marginBottom:'20px',color:'var(--navy)',fontWeight:'700'}}>✓ Message sent! We'll get back to you soon.</div>}
              <div className="form-row">
                <div className="form-group"><label>Your Name</label><input name="name" value={form.name} onChange={handle} placeholder="Full name"/></div>
                <div className="form-group"><label>Phone Number</label><input name="phone" value={form.phone} onChange={handle} placeholder="+91 XXXXX XXXXX"/></div>
              </div>
              <div className="form-group"><label>Email Address</label><input name="email" value={form.email} onChange={handle} placeholder="email@example.com"/></div>
              <div className="form-group"><label>Message</label><textarea name="msg" value={form.msg} onChange={handle} placeholder="Your message here..."></textarea></div>
              <button className="btn-submit" onClick={submit}>Send Message</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
